import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { RouteComponentProps } from "@reach/router";
import {
  Row,
  Col,
  Card,
  Typography,
  Form,
  Input,
  Button,
  notification,
} from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useStore } from "../store";

const styles = {
  constainer: {
    height: "100vh",
  },
  item: {
    marginBottom: "20px",
  },
  button: {
    width: "100%",
  },
};

interface Props extends RouteComponentProps {}
const Signin = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { auth } = useStore();
  const { t } = useTranslation();

  const signIn = async (credentials: { email: string; password: string }) => {
    try {
      setLoading(true);
      await auth.signInWithEmail(credentials);
    } catch (error) {
      notification.error({
        message: t("Sign in failed"),
        description: error.message,
      });
    }
    setLoading(false);
  };
  return (
    <Row justify="center" align="middle" style={styles.constainer}>
      <Col span={6}>
        <Card>
          <Form initialValues={{ remember: true }} onFinish={signIn}>
            <Typography.Title>{t("Sign In")}</Typography.Title>
            <Form.Item
              name="email"
              style={styles.item}
              rules={[
                { required: true, message: t("Please input your email!") },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder={t("Email")}
              />
            </Form.Item>
            <Form.Item
              name="password"
              style={styles.item}
              rules={[
                { required: true, message: t("Please input your Password!") },
              ]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={t("Password")}
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={styles.button}
              {...loading}
            >
              {t("Sign In")}
            </Button>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Signin;
